
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cleartax.in/webflow/preview/[partner]",
      function () {
        return require("private-next-pages/cleartax.in/webflow/preview/[partner]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cleartax.in/webflow/preview/[partner]"])
      });
    }
  